<template>
  <div class="date-range-dialog">
    <v-dialog v-model="dialog.monthlyInflowTotalDialog" scrollable>
      <v-card>
        <v-card-title>
          월별 유량
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row justify="space-between">
              <v-btn color="grey lighten-3" @click="prev">
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
              <div class="text-h4 pb-1">
              {{ calendar.title }}
              </div>
              <v-btn color="grey lighten-3" @click="next">
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </v-row>
            <v-row v-if="detectIE()" class="ie11-v-calendar-weekly">
                <v-calendar
                  ref="inflowCalendar"
                  v-model="calendar.calendar"
                  color="primary"
                  locale="ko-KR"
                  type="month"
                  :show-month-on-first=false
                  :event-more=false
                  :events="events"
                  :event-color="getEventColor"
                  :now=null
                  @change="changed"
                ></v-calendar>
            </v-row>
            <v-row v-else align="center" align-content="center" justify="center" class="big-font mt-2">
                <v-calendar
                  ref="inflowCalendar"
                  v-model="calendar.calendar"
                  color="primary"
                  locale="ko-KR"
                  type="month"
                  :event-more=false
                  :events="events"
                  :event-color="getEventColor"
                  :now=null
                  @change="changed"
                ></v-calendar>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-container>
            <v-row justify="end">
              <v-btn text @click="dialog.monthlyInflowTotalDialog = false">확인</v-btn>
              <v-btn text @click="downloadExcel"><v-icon>fa-file-download</v-icon>&nbsp;엑셀 다운로드</v-btn>
            </v-row>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import moment from 'moment'
  import axios from "axios";
  import egjsAgent from '@egjs/agent'

  export default {
    name: 'monthlyInflowTotalDialog',
    props: {
      dialog: {
        type: Object,
        required: true
      },
      item: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
        events: [
        ],
        calendar: {
          title: '',
          startTimestamp: 0,
          endTimestamp: 0
        },
      }
    },
    methods: {
      detectIE() {
        const agentInfo = egjsAgent();
        console.log(agentInfo);
        return agentInfo.browser.name === 'ie' || agentInfo.browser.name === 'edge';
      },
      changed(changedEvent) {
        console.log("calendar changed");
        console.dir(this.$refs.inflowCalendar);
        console.log(changedEvent)

        this.calendar.title = `${changedEvent.start.year}-${changedEvent.start.month}`

        this.getInflowEvents(changedEvent);
      },
      getInflowEvents(changedEvent) {
        const retryFuncBackup = this.getInflowEvents.bind(this, siteId);

        const siteId = this.item.siteId;

        const startMoment = moment(changedEvent.start.date, 'YYYY-MM-DD')
        const startTimestamp = startMoment.startOf('month').valueOf();
        let endTimestamp = startMoment.endOf('month').valueOf();
        const nowTimestamp = moment().valueOf();

        if (endTimestamp > nowTimestamp) {
          endTimestamp = moment(nowTimestamp).endOf('day').valueOf();
        }

        this.calendar.startTimestamp = startTimestamp;
        this.calendar.endTimestamp = endTimestamp;

        const baseUri = process.env.VUE_APP_API_SERVER;
        const targetUri = `${baseUri}/inflowTotals?siteId=${siteId}&startTimestamp=${startTimestamp}&endTimestamp=${endTimestamp}`;

        this.$bus.$emit('loading', true);

        const siengLoginInfoCookie = $cookies.get('siengLoginInfo');
        const config = {
          headers: {
            Authorization: `Bearer ${siengLoginInfoCookie.accessToken}`
          }
        };

        axios.get(targetUri, config)
          .then(result => {
            Object.entries(result.data).forEach(
              ([index, inflowEvent]) => {
                inflowEvent.timed = false;
                if ("today" === inflowEvent.type) {
                  inflowEvent.color = 'orange darken-2'
                } else if ("total" === inflowEvent.type) {
                  inflowEvent.color = 'blue darken-2'
                } else {
                  inflowEvent.color = 'blue darken-2'
                }
              }
            );

            this.events = result.data;

            console.log('inflow data loaded');
            console.dir(this.events);
          })
          .catch(error => {
            if (!error.hasOwnProperty('response')) {
              console.error(error);
              this.popupAlert(error.toString(), 'red');
              return;
            }

            if (error.response.status === 401 && "TOKEN_REFRESH_NEEDED" === error.response.data.detailedErrorCode) {
              this.$bus.$emit('refreshTokenAndRetryIfPossible', error, retryFuncBackup);
              return;
            }

            console.error(error.response);
            this.popupAlert(error.toString(), 'red');
          })
          .finally(() => {
            this.$bus.$emit('loading', false);
          });
      },
      downloadExcel() {
        const retryFuncBackup = this.downloadExcel.bind(this);

        const baseUri = process.env.VUE_APP_API_SERVER;
        const targetUri = `${baseUri}/inflowTotals/_excel?siteId=${this.item.siteId}&startTimestamp=${this.calendar.startTimestamp}&endTimestamp=${this.calendar.endTimestamp}`;

        this.$bus.$emit('loading', true);

        const siengLoginInfoCookie = $cookies.get('siengLoginInfo');
        const config = {
          headers: {
            Authorization: `Bearer ${siengLoginInfoCookie.accessToken}`
          },
          responseType: 'blob'
        };

        axios.get(targetUri, config)
          .then(result => {
            console.log('excel download');
            console.dir(result);
            let fileName = result.headers["content-disposition"].split("filename=")[1];
            if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE인 경우에
              window.navigator.msSaveOrOpenBlob(new Blob([result.data],
                {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
                fileName);
            } else {
              const url = window.URL.createObjectURL(new Blob([result.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', result.headers["content-disposition"].split("filename=")[1]);
              document.body.appendChild(link);
              link.click();
            }
          })
          .catch(error => {
            if (!error.hasOwnProperty('response')) {
              console.error(error);
              this.popupAlert(error.toString(), 'red');
              return;
            }

            if (error.response.status === 401 && "TOKEN_REFRESH_NEEDED" === error.response.data.detailedErrorCode) {
              this.$bus.$emit('refreshTokenAndRetryIfPossible', error, retryFuncBackup);
              return;
            }

            console.error(error.response);
            this.popupAlert(error.toString(), 'red');
          })
          .finally(() => {
            this.$bus.$emit('loading', false);
          });
      },
      prev() {
        this.$refs.inflowCalendar.prev()
        // this.changed(-1)
      },
      next() {
        this.$refs.inflowCalendar.next()
        // this.changed(1)
      },
      getEventColor(event) {
        return event.color
      },
      printDebugLog(target) {
        console.dir(target);
      },
      popupAlert(message, color) {
        this.$bus.$emit('popupAlert', {message: message, color: color});
      }
    },
    mounted() {
    }
  }
</script>

<style>
  .big-font .v-calendar .v-event {
    font-size: 14px;
  }

  .ie11-v-calendar-weekly .v-calendar-weekly {
    display: block;
  }
</style>